import React, { useContext, useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core'
import { cloneDeep, isNull } from 'lodash'
import MarblesChart from '../components/MarblesChart'
import MarblesLegend from '../components/MarblesLegend'
import SummaryStatsBox from '../components/SummaryStatsBox'
import generateRiskCounts from '../ultils/generateRiskCounts'
import { Context as PortfolioContext } from '../contexts/portfolio'
import { RISK_TYPE } from '../ultils/chart-d3-utils'

const useStyles = makeStyles({
  visArea: {
    flex: 1,
    // maxWidth: 1000,
    width: '40%',
  },
  indexBoard: {
    width: '30%',
  },
  chartContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#fff',
    border: '1px solid #DFE4EB',
    borderRadius: 5,
  },
  legendWrapper: {
    '@media only screen and (min-width: 900px)': {
      left: '58px',
      width: '33%',
    },
    '@media only screen and (min-width: 1500px)': {
      width: '30%',
      left: '14px',
    },
    height: 500,
    transformOrigin: 'center',
    transform: 'scale(1.1)',
    position: 'relative',
  },
})

const PortfolioToday = ({ tickers, riskType }) => {
  const classes = useStyles()
  const [tickerData, setTickerData] = useState(tickers)
  const riskCountData = generateRiskCounts(tickers, riskType)

  const { state, setActiveNode } = useContext(PortfolioContext)
  // TODO: move this logic to the context
  useEffect(() => {
    if (isNull(state.activeNode) || state.activeNode.name === 'total') {
      setTickerData(cloneDeep(tickers)) // name = total => reset
    } else {
      setTickerData(
        cloneDeep(tickers).filter(t =>
          riskType === RISK_TYPE.CREDIT
            ? t.credit_status === state.activeNode.name
            : t.status === state.activeNode.name,
        ),
      )
    }
  }, [state.activeNode, riskType])

  const setMarblesData = d => {
    setActiveNode(d)
  }

  return (
    <div className={classes.chartContainer}>
      <div className={classes.legendWrapper}>
        <MarblesLegend
          data={riskCountData}
          setMarblesData={setMarblesData}
          activeNode={state.activeNode}
        />
      </div>
      <div className={classes.visArea}>
        <MarblesChart
          isEmptyData={state.tickersInPortfolio.length === 0}
          tickers={tickerData}
          riskType={riskType}
          group="none"
        />
      </div>
      <div className={classes.indexBoard}>
        <SummaryStatsBox
          riskType={riskType}
          total={tickers.length}
          setMarblesData={setMarblesData}
          data={riskCountData}
          segmentClicked={state.activeNode}
          setSegmentClicked={setActiveNode}
        />
      </div>
    </div>
  )
}

export default PortfolioToday
